import { apiCall } from './gqlClient';
const GETMYBODYMEASUREMENTS_QUERY = "\n  query getMyBodyMeasurements {\n    getMyBodyMeasurements\n    {\n      id\n\t\t\tleanMass\n\t\t\tboneMass\n\t\t\tvisceralFat\n\t\t\tleftBiceps\n\t\t\trightBiceps\n\t\t\tchest\n\t\t\twaist\n\t\t\thips\n\t\t\tleftLeg\n\t\t\trightLeg\n\t\t\tleftCalf\n\t\t\trightCalf\n\t\t\theight\n\t\t\tweight\n\t\t\tdateCreated\n      ...fragments\n    }\n  }";
export const getMyBodyMeasurementsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMYBODYMEASUREMENTS_QUERY,
    variables: {},
    fragments
  });
};
const GETMYGOALS_QUERY = "\n  query getMyGoals {\n    getMyGoals\n    {\n      id\n\t\t\ttype\n\t\t\tgoal\n\t\t\tcompleted\n\t\t\tdateCreated\n\t\t\tdateCompleted\n      ...fragments\n    }\n  }";
export const getMyGoalsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMYGOALS_QUERY,
    variables: {},
    fragments
  });
};
const GETMYBODYMEASUREMENTSGRAPH_QUERY = "\n  query getMyBodyMeasurementsGraph {\n    getMyBodyMeasurementsGraph\n    {\n      id\n\t\t\tleanMass\n\t\t\tboneMass\n\t\t\tvisceralFat\n\t\t\tleftBiceps\n\t\t\trightBiceps\n\t\t\tchest\n\t\t\twaist\n\t\t\thips\n\t\t\tleftLeg\n\t\t\trightLeg\n\t\t\tleftCalf\n\t\t\trightCalf\n\t\t\theight\n\t\t\tweight\n\t\t\tdateCreated\n      ...fragments\n    }\n  }";
export const getMyBodyMeasurementsGraphApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMYBODYMEASUREMENTSGRAPH_QUERY,
    variables: {},
    fragments
  });
};
const UPDATEMYBODYMEASUREMENTS_QUERY = "\n  mutation updateMyBodyMeasurements($request: UserBodyMeasurementsInput!) {\n    updateMyBodyMeasurements(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateMyBodyMeasurementsApiCall = async function (_ref) {
  let {
    request
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEMYBODYMEASUREMENTS_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEMYGOALS_QUERY = "\n  mutation updateMyGoals($request: [UserGoalInput]!) {\n    updateMyGoals(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateMyGoalsApiCall = async function (_ref2) {
  let {
    request
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEMYGOALS_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const DELETEMYGOAL_QUERY = "\n  mutation deleteMyGoal($id: String!) {\n    deleteMyGoal(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteMyGoalApiCall = async function (_ref3) {
  let {
    id
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEMYGOAL_QUERY,
    variables: {
      id
    },
    fragments
  });
};